import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { BriefcaseIcon, GraduationCapIcon, UsersIcon, ArrowRightIcon } from 'lucide-react';
const ProgramsPage = () => {
  return <div className="bg-white min-h-screen w-full" data-id="element-722">
      <div className="relative h-64 md:h-80 lg:h-96 overflow-hidden" data-id="element-723">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2St8j7dtP7wGSk7uTwFS99/ayira_s_neuro_soul_cafe_cover.jpg" alt="Ayira's Cafe programs" className="w-full h-full object-cover" data-id="element-724" />
        <div className="absolute inset-0 bg-gradient-to-r from-green-900/60 to-amber-900/60 flex items-center justify-center" data-id="element-725">
          <h1 className="text-4xl md:text-5xl font-poppins font-bold text-white" data-id="element-726">
            Our Programs
          </h1>
        </div>
      </div>
      <div className="container mx-auto max-w-5xl py-16 px-6" data-id="element-727">
        <div className="text-center mb-12" data-id="element-728">
          <div className="inline-block mb-4 px-6 py-2 bg-green-100 text-green-800 rounded-full font-medium" data-id="element-729">
            Programs & Impact
          </div>
          <h2 className="text-3xl md:text-4xl font-poppins font-semibold mb-4" data-id="element-730">
            Three Pillars of Change
          </h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto font-poppins font-light" data-id="element-731">
            At Ayira's, we've developed a holistic approach to neurodiversity
            inclusion through three interconnected programs.
          </p>
        </div>
        {/* Training & Employment */}
        <div className="mb-16" data-id="element-732">
          <div className="bg-gradient-to-r from-green-50 to-green-100 rounded-lg overflow-hidden shadow-md" data-id="element-733">
            <div className="md:flex" data-id="element-734">
              <div className="md:w-2/5 relative" data-id="element-735">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2St8j7dtP7wGSk7uTwFS99/ayira_s_neuro_soul_cafe_cover.jpg" alt="Training & Employment for Neurodivergent Adults" className="w-full h-full object-cover" data-id="element-736" />
                <div className="absolute top-0 left-0 w-full h-full md:hidden bg-black bg-opacity-30" data-id="element-737"></div>
                <div className="absolute top-4 left-4 bg-green-500 text-white px-4 py-1 rounded-full text-sm font-medium" data-id="element-738">
                  Pillar 1
                </div>
              </div>
              <div className="md:w-3/5 p-8 md:p-10" data-id="element-739">
                <div className="flex items-center mb-4" data-id="element-740">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4" data-id="element-741">
                    <BriefcaseIcon size={24} className="text-green-600" data-id="element-742" />
                  </div>
                  <h3 className="text-2xl font-poppins font-semibold" data-id="element-743">
                    Training & Employment for Neurodivergent Adults
                  </h3>
                </div>
                <div className="prose prose-lg font-poppins" data-id="element-744">
                  <p className="font-light" data-id="element-745">
                    At Ayira's, we believe meaningful work is a right — not a
                    privilege. Our inclusive café and community hub are designed
                    to offer neurodivergent (ND) adults hands-on training in
                    hospitality, service, and essential life skills.
                  </p>
                  <h4 className="text-lg font-medium mt-6 mb-3" data-id="element-746">
                    Program Components:
                  </h4>
                  <ul className="space-y-2 font-light" data-id="element-747">
                    <li data-id="element-748">• Structured on-the-job training in café operations</li>
                    <li data-id="element-749">• Personalized coaching and skill development</li>
                    <li data-id="element-750">• Sensory-friendly work environment</li>
                    <li data-id="element-751">• Career pathway planning and support</li>
                  </ul>
                  <div className="mt-6 flex items-center" data-id="element-752">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2St8j7dtP7wGSk7uTwFS99/ayira_s_neuro_soul_cafe_cover.jpg" alt="Training & Employment" className="w-16 h-16 rounded-full object-cover mr-4" data-id="element-753" />
                    <Link to="/programs" className="text-green-600 hover:text-green-700 font-medium inline-flex items-center" data-id="element-754">
                      Learn more <ArrowRightIcon size={16} className="ml-1" data-id="element-755" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Joyful Journeys */}
        <div className="mb-16" data-id="element-756">
          <div className="bg-gradient-to-r from-amber-50 to-amber-100 rounded-lg overflow-hidden shadow-md" data-id="element-757">
            <div className="md:flex flex-row-reverse" data-id="element-758">
              <div className="md:w-2/5 relative" data-id="element-759">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/41G3iR6y97v8EQpUWQBShD/pexels-greta-hoffman-9706114.jpg" alt="Joyful Journeys program" className="w-full h-full object-cover" data-id="element-760" />
                <div className="absolute top-0 left-0 w-full h-full md:hidden bg-black bg-opacity-30" data-id="element-761"></div>
                <div className="absolute top-4 right-4 bg-amber-500 text-white px-4 py-1 rounded-full text-sm font-medium" data-id="element-762">
                  Pillar 2
                </div>
              </div>
              <div className="md:w-3/5 p-8 md:p-10" data-id="element-763">
                <div className="flex items-center mb-4" data-id="element-764">
                  <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mr-4" data-id="element-765">
                    <GraduationCapIcon size={24} className="text-amber-600" data-id="element-766" />
                  </div>
                  <h3 className="text-2xl font-poppins font-semibold" data-id="element-767">
                    Joyful Journeys (Caregiver & Educator Training)
                  </h3>
                </div>
                <div className="prose prose-lg font-poppins" data-id="element-768">
                  <p className="font-light" data-id="element-769">
                    Joyful Journeys is Ayira's signature training program,
                    co-designed by renowned Board Certified Behaviour Analyst
                    Dr. Jane Paul Weru, founder of PACA and EDS Training
                    Institute. Grounded in Applied Behaviour Analysis (ABA) and
                    culturally relevant practices, the program equips
                    caregivers, educators, and support staff with practical
                    tools to understand and support neurodivergent children.
                  </p>
                  <div className="mt-6 flex items-center" data-id="element-770">
                    <img src="https://joyfultherapy.health/wp-content/uploads/2024/11/bonding-moment-betwen-parent-and-child-683x1024.jpg" alt="Joyful Journeys" className="w-16 h-16 object-cover rounded-full mr-4" data-id="element-771" />
                    <a href="https://joyfultherapy.health/" target="_blank" rel="noopener noreferrer" className="text-amber-600 hover:text-amber-700 font-medium inline-flex items-center" data-id="element-772">
                      Learn more <ArrowRightIcon size={16} className="ml-1" data-id="element-773" />
                    </a>
                  </div>
                  <h4 className="text-lg font-medium mt-6 mb-3" data-id="element-774">
                    Program Components:
                  </h4>
                  <ul className="space-y-2 font-light" data-id="element-775">
                    <li data-id="element-776">• Evidence-based training in ABA techniques</li>
                    <li data-id="element-777">• Culturally-relevant support strategies</li>
                    <li data-id="element-778">• Hands-on workshops and coaching</li>
                    <li data-id="element-779">• Ongoing community of practice</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Community Events */}
        <div className="mb-16" data-id="element-780">
          <div className="bg-gradient-to-r from-purple-50 to-purple-100 rounded-lg overflow-hidden shadow-md" data-id="element-781">
            <div className="md:flex" data-id="element-782">
              <div className="md:w-2/5 relative" data-id="element-783">
                <img src="https://images.unsplash.com/photo-1511632765486-a01980e01a18?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" alt="Community Events & Inclusion Workshops" className="w-full h-full object-cover" data-id="element-784" />
                <div className="absolute top-0 left-0 w-full h-full md:hidden bg-black bg-opacity-30" data-id="element-785"></div>
                <div className="absolute top-4 left-4 bg-purple-500 text-white px-4 py-1 rounded-full text-sm font-medium" data-id="element-786">
                  Pillar 3
                </div>
              </div>
              <div className="md:w-3/5 p-8 md:p-10" data-id="element-787">
                <div className="flex items-center mb-4" data-id="element-788">
                  <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mr-4" data-id="element-789">
                    <UsersIcon size={24} className="text-purple-600" data-id="element-790" />
                  </div>
                  <h3 className="text-2xl font-poppins font-semibold" data-id="element-791">
                    Community Events & Inclusion Workshops
                  </h3>
                </div>
                <div className="prose prose-lg font-poppins" data-id="element-792">
                  <p className="font-light" data-id="element-793">
                    At Ayira's, we believe that true inclusion begins with
                    awareness and shared experiences. Our community events and
                    hands-on workshops are designed to break stigma, build
                    empathy, and promote practical inclusion across society.
                  </p>
                  <h4 className="text-lg font-medium mt-6 mb-3" data-id="element-794">
                    Program Components:
                  </h4>
                  <ul className="space-y-2 font-light" data-id="element-795">
                    <li data-id="element-796">
                      • Collaborative events with inclusive schools and advocacy
                      groups
                    </li>
                    <li data-id="element-797">• Parent Empowerment Workshops</li>
                    <li data-id="element-798">• Inclusive Education Days</li>
                    <li data-id="element-799">• Employer inclusion training</li>
                    <li data-id="element-800">
                      • Recognition of International Day of Persons with
                      Disabilities
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* CTA Section */}
        <div className="text-center" data-id="element-801">
          <div className="bg-gradient-to-r from-green-50 via-amber-50 to-purple-50 rounded-lg p-8 shadow-sm" data-id="element-802">
            <h3 className="text-2xl font-poppins font-semibold mb-4" data-id="element-803">
              Join Our Movement
            </h3>
            <p className="text-gray-700 mb-6 max-w-2xl mx-auto font-poppins font-light" data-id="element-804">
              Whether you're a parent seeking support, an employer interested in
              inclusion, or simply someone who believes in our mission, there
              are many ways to get involved with Ayira's.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-805">
              <Link to="/visit" className="inline-block bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-md font-medium transition duration-300" data-id="element-806">
                Visit Our Café
              </Link>
              <Link to="/future-hub" className="inline-block bg-purple-600 hover:bg-purple-700 text-white px-6 py-3 rounded-md font-medium transition duration-300" data-id="element-807">
                Learn About Our Future Hub
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default ProgramsPage;